import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-6" }
const _hoisted_2 = { class: "_flex _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_title = _resolveComponent("base-title")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: "Crowdfunding Glossary",
    "is-visible": $props.isVisible,
    icon: "book-open",
    "show-action-close": "",
    width: "wide",
    onActionClose: $options.onModalClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.dictionary, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title,
            class: "_flexcol _gap-1"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_base_icon, {
                name: item.icon,
                class: "_tc--accent"
              }, null, 8 /* PROPS */, ["name"]),
              _createVNode(_component_base_title, { level: "h3" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            _createElementVNode("div", null, _toDisplayString(item.description), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "onActionClose"]))
}